<script setup lang="ts">
import { toastState, dismissToast, runToastAction } from '../composables/useToast';
import { Icon } from './icons';

const ICON = { success: Icon.Check, error: Icon.X, info: Icon.Spark } as const;
</script>

<template>
  <div class="app-toaster" role="status" aria-live="polite">
    <TransitionGroup name="app-toast">
      <div
        v-for="t in toastState.items"
        :key="t.id"
        :class="['app-toast', t.kind]"
        title="点击关闭"
        @click="dismissToast(t.id)"
      >
        <span class="ic" v-html="ICON[t.kind]" />
        <span class="tx">{{ t.text }}</span>
        <button
          v-if="t.action"
          type="button"
          class="act"
          @click.stop="runToastAction(t.id)"
        >{{ t.action.label }}</button>
      </div>
    </TransitionGroup>
  </div>
</template>

<style scoped>
.app-toaster {
  position: fixed;
  top: 64px; left: 50%;
  transform: translateX(-50%);
  z-index: 300;
  display: flex; flex-direction: column; align-items: center; gap: var(--sp-2);
  width: min(420px, calc(100vw - 24px));
  pointer-events: none;
}
.app-toast {
  pointer-events: auto;
  display: flex; align-items: flex-start; gap: 10px;
  max-width: 100%;
  padding: 10px var(--sp-4);
  border-radius: var(--radius-l);
  background: var(--color-surface);
  border: 1px solid var(--border-default);
  box-shadow: var(--shadow-pop);
  font-size: var(--fs-label); line-height: 1.5; color: var(--text-primary);
  cursor: pointer;
  word-break: break-word;
}
.app-toast .ic {
  flex-shrink: 0;
  width: 20px; height: 20px; border-radius: 50%;
  display: inline-flex; align-items: center; justify-content: center;
  margin-top: 1px;
}
.app-toast .ic :deep(svg) { width: 12px; height: 12px; }
.app-toast .tx { flex: 1; min-width: 0; }
/* 操作按钮: 点按区域至少 36px 高 (手机 40px), 用负外边距抵消提示条内边距, 提示条不跟着变高 */
.app-toast .act {
  flex-shrink: 0;
  align-self: center;
  margin: -8px -8px -8px 4px;
  min-width: 48px;
  height: var(--ctl-h); padding: 0 12px;
  border: none; border-radius: var(--radius-s);
  background: transparent;
  font: inherit; font-size: var(--fs-label); font-weight: 600;
  color: var(--primary);
  cursor: pointer;
}
.app-toast .act:hover { background: var(--primary-bg); }
.app-toast.success .ic { background: var(--success-bg); color: var(--success); }
.app-toast.error { border-color: color-mix(in oklab, var(--danger) 30%, var(--border-default)); }
.app-toast.error .ic { background: var(--danger-bg); color: var(--danger); }
.app-toast.info .ic { background: var(--primary-bg); color: var(--primary); }

.app-toast-enter-active, .app-toast-leave-active { transition: all 200ms var(--ease-out); }
.app-toast-enter-from, .app-toast-leave-to { opacity: 0; transform: translateY(-8px); }

@media (max-width: 720px) {
  .app-toaster { top: 56px; }
  .app-toast .act { height: 40px; margin: -10px -10px -10px 4px; }
}
</style>
